const isLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const MAIN_API_BASE = process.env.REACT_APP_MAIN_API_BASE || (isLocal ? "http://localhost:5000/api" : "/api");
export const ADMIN_API_BASE = process.env.REACT_APP_ADMIN_API_BASE || (isLocal ? "http://localhost:5001" : "https://bitmartadmin.com/api");
